import * as React from "react";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { theme } from "../../theme/theme";
import { Card, CardMedia, CardContent, Typography, CardActions, IconButton, Chip } from "@material-ui/core";
// import ChartIcon from "../Icons/ChartIcon";
import PropalIcon from "../Icons/PropalIcon";

import { styles } from "./Product.style";
import { getProductDico } from "../../helper/functions.helper";
// import { Benchmark } from "../../types/Benchmark";
// import BenchmarkPopin from "../Benchmark/BenchmarkPopin";
import { ProductName, ProductVariantName } from "src/types/Products";

interface ProductProps {
    name: ProductName;
    variant?: ProductVariantName;
    push(path: string);
}

interface ProductState {
    image: string;
    // popinOpened: boolean;
}

class Product extends React.Component<ProductProps & WithStyles<typeof styles>, ProductState> {

    dico: any = null;

    state = {
        // popinOpened: false,
        image: ""
    };

    async componentWillMount () {
        this.dico = getProductDico(this.props.name, this.props.variant);
        const image: string = await this.getImage(this.props.name + (this.props.variant ? "_" + this.props.variant : ""));
        this.setState({ image: image });
    }

    // public onBenchmarkPopinState(state: boolean) {
    //     this.setState({popinOpened: state});
    // }

    public render() {
        if (!this.state) {
            return null;
        }

        const classes = this.props.classes;
        // const { popinOpened } = this.state;
        const link = `${this.props.name}${this.props.variant ? "/" + this.props.variant : ""}`;

        return (
            <Card className={classes.card}>
                <a style={{cursor: "pointer"}} onClick={() => this.props.push(`/product/${link}`)}>
                    <header className={classes.header}>
                        <Typography variant="display1" component="h3" className={classes.title}>{this.dico.cover.title}</Typography>
                        {this.state.image && <CardMedia
                            className={classes.media}
                            image={this.state.image}
                        />}
                        <Chip
                            label={this.dico.cover.tag}
                            className={classes.tag}
                        />
                    </header>
                    <CardContent className={classes.content}>
                        <Typography gutterBottom={true} variant="subheading" component="h4">{this.dico.cover.age}</Typography>
                        <Typography component="p">{this.dico.cover.topic}</Typography>
                    </CardContent>
                </a>
                <CardActions className={classes.actions}>
                    <Typography
                        variant="caption"
                        component="small"
                        className={classes.more}
                        onClick={() => this.props.push(`/product/${link}`)}
                    >
                        En savoir plus
                    </Typography>
                    <IconButton 
                        className={classes.button} 
                        color="primary"
                        onClick={() => this.props.push(`/quotation/${link}`)}
                    >
                        <PropalIcon nativeColor={theme.palette.primary.main}/>
                    </IconButton>
                    {/* <IconButton
                        className={classes.button}
                        color="primary"
                        onClick={() => this.onBenchmarkPopinState(true)}
                    >
                        <ChartIcon nativeColor={theme.palette.primary.main}/>
                    </IconButton>
                    <BenchmarkPopin
                        data={this.dico.benchmark as Benchmark}
                        open={popinOpened}
                        onClick={() => this.onBenchmarkPopinState(false)}
                    /> */}
                </CardActions>
            </Card>
        );
    }

    private async getImage(name: string) {
        return await import (`./assets/${name.toLowerCase()}.jpg`);
    }

}

export default withStyles(styles)(Product);


// WEBPACK FOOTER //
// ./src/components/Product/Product.tsx